<template>
  <section class="custom-measurements">
    <!-- <div class="row">
      <div class="col-md-12 custom-header">
        <div class="input-group custom-title"></div>
        <week-selector
          class="custom-selector"
          :weeks="weeks"
          :week="week"
          @change="changingWeek"
        />
      </div>
    </div> -->
    <div class="row">
      <div class="col-2">
        <div class="row mb-2">
          <div class="col" v-show="currentTab === 'Measurements'">
            <button class="btn btn-primary btn-sm" @click="addMeasurement">
              Add Measurement
            </button>
          </div>
        </div>
        <div class="row custom-list">
          <div class="col">
            <!-- Measurement Listing here -->
            <table class="table table-bordered table-striped">
              <tr v-for="item of dates" :key="item.id" class="custom-row">
                <td>
                  <input
                    type="checkbox"
                    class="z-checkbox-small"
                    :checked="item.checked"
                    :value="item.id"
                    :disabled="item.disabled"
                    @click="checked(item.id, $event.target.checked)"
                  />
                </td>
                <td>{{ item.date }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-10">
        <div class="row">
          <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
        </div>
        <div class="row p-3" v-if="currentTab === 'Measurements'">
          <measurements />
        </div>
        <div class="row p-3" v-if="currentTab === 'Photos'">
          <measurement-photos @reload="reloadPhotos" />
        </div>
      </div>
    </div>
  </section>
  <size-measurement-add-dialog
    :show="actionMeasurementAdd"
    @close="closeDialogs"
    @saved="savedMeasurement"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import globals from '@/Plugins/globals'
import ZTabs from '@/Components/ZElements/Tabs'
import WeekSelector from '../elements/week-selector'
import Measurements from '../elements/measurements'
import MeasurementPhotos from '../elements/measurement-photos'
import SizeMeasurementAddDialog from './sizemeasurement/size-measurement-add-dialog'
export default {
  name: 'client-measurements',
  components: {
    ZTabs,
    WeekSelector,
    Measurements,
    MeasurementPhotos,
    SizeMeasurementAddDialog,
  },
  data() {
    return {
      currentTab: 'Measurements',
      actionMeasurementAdd: null,
    }
  },
  mounted() {
    this.weekChanged()
  },
  emits: ['changed', 'weekChanged'],
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('measurements', ['measurements', 'photos']),
    tabs() {
      let _tabs = []
      _tabs.push('Measurements')
      if (this.isProgressPhotos) {
        _tabs.push('Photos')
      }
      return _tabs
    },
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.week.name
      }
      return _data
    },
    date() {
      let _data = ''
      if (this.summary) {
        _data = moment(this.summary.week.value).format('YYYY-MM-DD')
      }
      return _data
    },
    dates() {
      let _data = []
      if (this.currentTab === 'Measurements') {
        // _data = globals.sortArray(
        //   JSON.parse(JSON.stringify(this.measurements)),
        //   'measurement_date',
        //   'asc'
        // )
        _data = this.measurements
      } else {
        // _data = globals.sortArray(
        //   JSON.parse(JSON.stringify(this.photos)),
        //   'photo_date',
        //   'asc'
        // )
        _data = this.photos
      }
      return _data
    },
    isProgressPhotos() {
      let _is = false
      if (this.summary) {
        if (this.summary.organization) {
          if (
            parseInt(this.summary.organization.progressPhotosVisibility) ===
              1 ||
            parseInt(this.summary.organization.progressPhotosVisibility) === 2
          ) {
            _is = true
          }
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('measurements', [
      'getMeasurements',
      'getPhotos',
      'setChecked',
    ]),
    // async init() {
    //   if (this.member === undefined || this.member === null) {
    //     let data = {
    //       userId: this.member.id,
    //       orgId: this.examineOrganization.id,
    //       date: this.date,
    //     }
    //     await this.getMeasurements(data)
    //     await this.getPhotos(data)
    //   }
    //   await this.weekChanged()
    // },
    showTab(value) {
      this.currentTab = value
    },
    async changingWeek(week) {
      await this.weekChanged(week)
      this.$emit('changed')
    },
    closeDialogs() {
      this.actionMeasurementAdd = null
    },
    addMeasurement() {
      this.actionMeasurementAdd = true
    },
    async savedMeasurement() {
      let data = {
        userId: this.member.id,
        orgId: this.examineOrganization.id,
        date: this.date,
      }
      await this.getMeasurements(data)
      this.actionMeasurementAdd = null
    },
    async weekChanged(date) {
      if (this.member === undefined || this.member === null) {
        await this.getMember({
          id: this.member.id,
          date: this.date,
        })
      }
      let data = {
        userId: this.member.id,
        orgId: this.examineOrganization.id,
        date: this.date,
      }
      await this.getMeasurements(data)
      await this.getPhotos(data)
      this.$emit('weekChanged', date)
    },
    async reloadPhotos() {
      let data = {
        userId: this.member.id,
        orgId: this.examineOrganization.id,
        date: this.date,
      }
      console.log('Calling Get Photos', data)
      await this.getPhotos(data)
    },
    checked(id, value) {
      let data = {
        id: id,
        value: value,
        for: this.currentTab,
      }
      this.setChecked(data)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-measurements {
  min-height: 400px;
}
.custom-header {
  position: relative;
}
.custom-title {
  position: absolute;
  left: 0;
  top: 0;
  button {
    top: -10px;
  }
}
.custom-selector {
  width: 265px;
  margin: 0 auto;
}
.custom-border {
  border-bottom: 1px solid rgb(222, 226, 230);
}
.custom-list {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 400px;
}
.custom-row {
  height: 42px;
}
</style>
